// @flow
import JQueryView, { on } from '../../../common/JQueryView';
import swal from 'sweetalert';

export default class FormView extends JQueryView {
  isReviewOpened: boolean;

  constructor(isReviewOpened: boolean) {
    super('.simple_form');
    this.isReviewOpened = isReviewOpened;
    if (this.isReviewOpened) $('.confirm-label').text('確認済');
  }

  @on('click #agree_use_group_chat')
  onClickClause() {
    this.isReviewOpened = true;
    $('.confirm-label').text('確認済');
  }

  @on('click input[name="commit"]')
  onSubmit() {
    if (!this.isReviewOpened) {
      swal({
        title: '取引約款および事前審査依頼書の内容をご確認ください',
        confirmButtonColor: '#2196F3',
        animation: false,
      });
      return false;
    } else {
      return true;
    }
  }
}
